'use client';

import { useDrawerHeaderNavigation_unstable } from '@fluentui/react-drawer';

/**
 * Returns the state for a DrawerHeaderNavigation component, given its props and ref.
 */
export const useDrawerHeaderNavigation = useDrawerHeaderNavigation_unstable;
